import React, { useEffect, useLayoutEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { signOutEffect } from 'app/store/Auth/effects';
import { ChakraAppLoader } from 'app/components/Core';
import { useIntercom } from 'react-use-intercom';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';

export const SignOut: React.FC = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { hardShutdown } = useIntercom();

  useLayoutEffect(() => {
    hardShutdown();
  }, [hardShutdown]);

  useEffect(() => {
    const signOut = async () => {
      await dispatch(signOutEffect({ pathname }));
      if (pathname !== '/') {
        navigate(routes.auth.path, { replace: true });
      }
      window.location.reload();
    };
    signOut();
  }, [dispatch, navigate, pathname]);

  return <ChakraAppLoader />;
};
